import React, { useEffect, useState } from 'react';
import ActionButton from './ActionButton';
import { useCart } from '../context/CartContext';

const ComboCard = ({ combo }) => {
  const [quantity, setQuantity] = useState(1);
  const [confirmation, setConfirmation] = useState(null);
  const { addItem } = useCart();

  const handleAddToCart = () => {
    const qty = quantity;
    addItem(
      { id: combo.id, name: combo.name, price: combo.price, type: 'combo', image: combo.image || null },
      qty
    );
    setConfirmation(`${qty}× ${combo.name} added to cart!`);
    setQuantity(1);
  };

  useEffect(() => {
    if (!confirmation) return undefined;
    const timeout = setTimeout(() => setConfirmation(null), 2800);
    return () => clearTimeout(timeout);
  }, [confirmation]);

  return (
    <article className="combo-card">
      <div className="combo-image">
        <img src={combo.image} alt={combo.name} loading="lazy" />
      </div>
      <div className="combo-content">
        <div className="combo-heading">
          <h3>{combo.name}</h3>
          <span className="combo-price">₦{combo.price.toLocaleString()}</span>
        </div>
        <p>{combo.description}</p>
        <p className="combo-savings">{combo.savingsText}</p>
        <ul>
          {combo.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <div className="combo-card-quantity">
          <label htmlFor={`qty-${combo.id}`}>Qty:</label>
          <div className="quantity-controls">
            <button
              onClick={() => setQuantity(Math.max(1, quantity - 1))}
              aria-label="Decrease quantity"
            >
              −
            </button>
            <input
              id={`qty-${combo.id}`}
              type="number"
              min="1"
              value={quantity}
              onChange={(e) => setQuantity(parseInt(e.target.value) || 1)}
            />
            <button
              onClick={() => setQuantity(quantity + 1)}
              aria-label="Increase quantity"
            >
              +
            </button>
          </div>
        </div>
        <ActionButton 
          variant="primary" 
          size="sm"
          onClick={handleAddToCart}
          className="combo-add-btn"
        >
          Add to order
        </ActionButton>
        {confirmation && (
          <p className="combo-added-feedback">{confirmation}</p>
        )}
      </div>
    </article>
  );
};

export default ComboCard;